import type { CekAjaT } from '~/types/cekaja'

export const useCekAjaStore = defineStore('cek-aja', () => {
  const form = ref<CekAjaT>({
    origin: null,
    originTitle: undefined,
    destination: null,
    destinationTitle: undefined,
    weight: undefined,
    width: undefined,
    height: undefined,
    length: undefined
  })

  const loadOnMount = ref(false)

  const getForm = computed(() => form.value)
  const getLoadOnMount = computed(() => loadOnMount.value)

  const setForm = (payload?: Partial<CekAjaT>) => {
    form.value = { ...form.value, ...payload }
  }
  const setLoadOnMount = (payload: boolean) => {
    loadOnMount.value = payload
  }

  return {
    form,
    getForm,
    setForm,
    loadOnMount,
    getLoadOnMount,
    setLoadOnMount
  }
})
